import { render } from "./OrthoLanguages.vue?vue&type=template&id=6a544286&scoped=true"
import script from "./OrthoLanguages.vue?vue&type=script&lang=js"
export * from "./OrthoLanguages.vue?vue&type=script&lang=js"

import "./OrthoLanguages.vue?vue&type=style&index=0&id=6a544286&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a544286"]])

export default __exports__